import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#bfbfcc",
      d: "M15.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#bfbfcc",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }, null, -1)
  ]))]))
}
export default { render: render }